// collection.js
const historyData = [
  "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam nobis beatae obcaecati numquam animi ipsa asperiores ipsum perferendis, earum error atque tempora voluptates non ipsam quod reprehenderit minima possimus dolores?",
  "Another milestone was achieved as we expanded our diagnostic services across the region with cutting-edge equipment and a dedicated team.",
  "We integrated electronic health records (EHR) to streamline patient information and improve doctor-patient collaboration.",
  "Our community outreach programs began, offering free diagnostic tests to underserved areas.",
  "We received accreditation from multiple health organizations, solidifying our commitment to quality and accuracy.",
  "Continuing innovation, we launched mobile access to results, empowering patients with real-time health updates.",
];

export default historyData;
